export const constants = {
  id: 'benefits',
  name: 'Benefits',
  title: 'Why Choose Us',
  // thumb: process.env.PUBLIC_URL + '/asset/blue-sphere.png',
  thumb:
    'https://github.com/RootChain-kr/rootchain-kr.github.io/blob/gh-pages/asset/blue-sphere.png?raw=true',
};

export const benefits = [
  {
    id: 'infra',
    en: 'Establishing an efficient blockchain infrastructure',
    ko: '효율적 블록체인 인프라 구축',
  },
  {
    id: 'data',
    en: 'High-performance/High-efficiency distributed data processing',
    ko: '고성능/고효율 분산 데이터 처리',
  },
  {
    id: 'template',
    en: 'Standardized service template',
    ko: '고성능/고효율 분산 데이터 처리',
  },
  {
    id: 'platform',
    en: 'High compatibility between heterogeneous blockchains',
    ko: '이기종 블록체인 간 높은 호환성',
  },
  {
    id: 'system',
    en: 'Stable and verified blockchain system',
    ko: '안정적이고 검증된 블록체인 시스템',
  },
  {
    id: 'service',
    en: 'Expansion of various services based on blockchain',
    ko: '블록체인 기반 각종 서비스 확장',
  },
];
